import { InsuredAttributesDto } from './calculation/InsuredAttributesDto';
import { CoverTypeEnum } from '../enums/CoverTypeEnum';
import { ProductTypeEnum } from '../enums/ProductTypeEnum';
import { AdaptedEntry } from './AdaptedEntry';
import { PolicyTerms } from '../enums/PolicyTermsEnum';

export class CalculationRequestDto {
  productType: ProductTypeEnum;
  policyTerms: PolicyTerms;
  insureds: InsuredAttributesDto[] = [];
  typeOfCover: CoverTypeEnum;
  annuityRate: number;
  sumAssuredAtEnd: number;
  dateOfCommencement: Date;
  numberOfYears: number;
  variables: Record<string, AdaptedEntry> = {};
  constructor(productType, policyTerms) {
    this.productType = productType;
    this.policyTerms = policyTerms;
  }
}
